// extracted by mini-css-extract-plugin
export default {"img":"BroadcastItem_img__APqpv","title":"BroadcastItem_title__+09SV"};